/** @format */

import { takeLatest, put, all, call, select } from 'redux-saga/effects';
import axios from 'axios';
import VoucherActionTypes from './voucher.types';
import { selectCurrentUser } from '../user/user.selector';
import {
  selectVoucherDate,
  selectVoucherSelectedKeys,
  selectVoucherSelectedCustomers,
  selectVoucherSelectedInvSegKey,
} from './voucher.selector';
import {
  fetchVoucherInvSegKeySuccess,
  fetchVoucherInvSegKeyFailure,
  fetchVoucherBatchCustomersSuccess,
  fetchVoucherBatchCustomersFailure,
  sendVoucherEmailSuccess,
  sendVoucherEmailFailure,
  setVoucherSelectedCustomers,
} from './voucher.actions';

export function* fetchInvSegmentKeys() {
  try {
    const currentUser = yield select(selectCurrentUser);
    const voucherDate = yield select(selectVoucherDate);
    const resp = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/automation/getbatchvouchers',
      method: 'post',
      data: {
        userAuth: currentUser,
        date: voucherDate,
      },
    });
    yield put(fetchVoucherInvSegKeySuccess(resp.data.invSegKeys));
  } catch (error) {
    yield put(fetchVoucherInvSegKeyFailure(error));
  }
}

export function* fetchBatchCustomers() {
  try {
    const currentUser = yield select(selectCurrentUser);
    const voucherDate = yield select(selectVoucherDate);
    const selectedKeys = yield select(selectVoucherSelectedKeys);
    const selectedCustomers = yield select(selectVoucherSelectedCustomers);

    console.log('Selcted Keys: ', selectedKeys);

    yield put(setVoucherSelectedCustomers([]));

    if (selectedKeys.length === 0) {
      yield put(fetchVoucherBatchCustomersSuccess([]));
      return;
    }
    const resp = yield call(axios, {
      url:
        process.env.REACT_APP_LOCAL_URL + '/automation/getcustomervoucherdata',
      method: 'post',
      data: {
        userAuth: currentUser,
        date: voucherDate,
        voucherIssuanceIds: selectedKeys,
      },
    });
    yield put(fetchVoucherBatchCustomersSuccess(resp.data.customerData));
    yield put(setVoucherSelectedCustomers([...resp.data.customerData]));
  } catch (error) {
    yield put(fetchVoucherBatchCustomersFailure(error));
  }
}

export function* onFetchVoucherInvSegKeysStart() {
  yield takeLatest(
    VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_START,
    fetchInvSegmentKeys
  );
}

export function* sendVoucherEmail() {
  try {
    const currentUser = yield select(selectCurrentUser);
    const voucherDate = yield select(selectVoucherDate);
    const selectedKeys = yield select(selectVoucherSelectedInvSegKey);
    const selectedCustomers = yield select(selectVoucherSelectedCustomers);

    const resp = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/sendgrid/sendvouchers',
      method: 'post',
      data: {
        userAuth: currentUser,
        date: voucherDate,
        voucherInvSegKeys: selectedKeys,
        customers: selectedCustomers,
      },
    });
    yield put(sendVoucherEmailSuccess(resp.data.messageData));
  } catch (error) {
    yield put(sendVoucherEmailFailure(error));
  }
}

export function* onSetVoucherDate() {
  yield takeLatest(VoucherActionTypes.SET_VOUCHER_DATE, fetchInvSegmentKeys);
}

// export function* setSelectedKeys() {
//   yield takeLatest(
//     VoucherActionTypes.SET_VOUCHER_SELECTED_KEYS,
//     fetchBatchCustomers
//   );
// }

export function* onFetchCustomers() {
  yield takeLatest(
    VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_START,
    fetchBatchCustomers
  );
}

export function* onSendVoucherEmailStart() {
  yield takeLatest(
    VoucherActionTypes.SEND_VOUCHER_EMAIL_START,
    sendVoucherEmail
  );
}

export function* voucherSagas() {
  yield all([
    call(onFetchVoucherInvSegKeysStart),
    call(onSetVoucherDate),
    // call(setSelectedKeys),
    call(onFetchCustomers),
    call(onSendVoucherEmailStart),
  ]);
}
